import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Subheader from "material-ui/Subheader";
import { List, ListItem, makeSelectable } from "material-ui/List";
import Napp from "./napp";
import MyFinance from "./my-finance";
import Webhooks from "./webhooks";
import Sat from "./sat";
import Tray from "./tray";
import MercadoPago from "./mercado-pago";
import OrderIntegrations from "./order_integrations";
import Oms from "./oms";
import { observer } from "mobx-react";
import "./integrations.css";

const SelectableList = makeSelectable(List);

class CompanyFormIntegrations extends Component {
  static integrationsTree = [
    {
      label: "MyFinance",
      component: MyFinance,
      isCompanyAllowed: () => true
    },
    {
      label: "Webhooks",
      component: Webhooks,
      isCompanyAllowed: () => true
    },
    {
      label: "SAT",
      component: Sat,
      isCompanyAllowed: company => company.address.state === "SP"
    },
    {
      label: "Napp",
      component: Napp,
      isCompanyAllowed: () => true
    },
    {
      label: "Tray",
      component: Tray,
      isCompanyAllowed: () => true
    },
    {
      label: "Mercado Pago",
      component: MercadoPago,
      isCompanyAllowed: () => true
    },
    {
      label: "Pedidos Externos",
      component: OrderIntegrations,
      isCompanyAllowed: () => true
    },
    {
      label: "Nexaas OMS",
      component: Oms,
      isCompanyAllowed: () => true
    }
  ];

  constructor(props) {
    super(props);

    this.state = {
      integration: {
        label: "",
        component: null
      }
    };
  }

  setIntegrationHandle = (_, selected) => {
    const integration = CompanyFormIntegrations.integrationsTree.find(
      integration => integration.label === selected
    );
    this.setState({ integration });
  };

  currentComponent = () => {
    if (this.state.integration.component) {
      return (
        <this.state.integration.component
          company={this.props.company}
          updateVmMyFinanceIntegration={params =>
            this.props.updateVmMyFinanceIntegration(params)
          }
        />
      );
    }
  };

  integrationListItem = integration => {
    const canAccessItem = integration.isCompanyAllowed(this.props.company);

    return (
      <ListItem
        value={integration.label}
        key={integration.label}
        primaryText={integration.label}
        className={
          canAccessItem ? "" : "company-form__integrations__not_allowed_item"
        }
        disabled={!canAccessItem}
      />
    );
  };

  render() {
    return (
      <div className="grid-container">
        <Row>
          <Col
            lg={3}
            md={4}
            sm={5}
            xs={5}
            className="company-form__integrations__list"
          >
            <SelectableList
              value={this.state.integration.label}
              onChange={this.setIntegrationHandle}
            >
              <Subheader>Integrações</Subheader>
              {CompanyFormIntegrations.integrationsTree.map(
                this.integrationListItem
              )}
            </SelectableList>
          </Col>
          <Col lg={9} md={8} sm={7} xs={7}>
            {this.currentComponent()}
          </Col>
        </Row>
      </div>
    );
  }
}

export default observer(CompanyFormIntegrations);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/index.jsx